import React from 'react';
import { SUBSCRIPTION_CANCELLED_TYPES } from '../../../../../common/constants';
import ModalComponent from '../../../../../components/ModalComponent';

const SubscriptionNoteModal = ({ note, isModalOpen, setIsModalOpen }) => {
  const reason = note?.cancellationData?.reason?.trim();
  const description = note?.cancellationData?.description?.trim();

  return (
    <ModalComponent
      open={isModalOpen}
      title="Cancellation Note"
      onCancel={() => {
        setIsModalOpen(false);
      }}
      footer={null}
    >
      {SUBSCRIPTION_CANCELLED_TYPES?.[note?.cancelledType] &&
        (reason || description) && (
          <div className="font-size-16">
            {reason && <div>Reason: {reason}</div>}
            {description && <div>Description: {description}</div>}
          </div>
        )}
    </ModalComponent>
  );
};

export default SubscriptionNoteModal;
